import React, { useContext, useEffect, useState } from "react";
import {
  getProductMaster,
  deleteProductMaster,
  updateProductMaster,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditProductMaster } from "./pform";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom";

const ProductMaster = () => {
  const { showLoader, hideLoader, shopItem, UserItem, warehouse } = useContext(WarehouseContext);

  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  // const { showLoader, hideLoader } = useContext(WarehouseContext);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    cat_id: "",
    status: "1",
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState(true);

  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rolesPerPage = 10;

  useEffect(() => {
    fetchProducts();
  }, []);

  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const fetchProducts = async (page = currentPage, text = "") => {
    showLoader();
    try {
      const params = {
        shop_id: shopItem?.shop_id || "0",
        // ware_id: warehouse?.id || "1",
        page,
        search: text,
      };

      const response = await getProductMaster(params);

      if (response.data && response.data.data) {
        setProducts(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching product master data:", error);
      toast.error("Failed to fetch products");
    } finally {
      hideLoader();
    }
  };

  const openAddModal = () => {
    setAddOrEdit(true);
    setSelectedProduct(null);
    setShowEditModal(true);
  };

  const openEditModal = (prod) => {
    setSelectedProduct(prod);
    setAddOrEdit(false);
    setShowEditModal(true);
  };

  const handleDelete = async () => {
    if (!deleteID) {
      toast.error("No product selected to delete");
      return;
    }

    try {
      await deleteProductMaster(deleteID);
      showDeletemodel(false);
      toast.success("Product deleted");
      fetchProducts(currentPage);
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Error deleting product");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchProducts(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchProducts(1, text);
    setCurrentPage(1);
  };

  const activateProduct = async (value) => {
    showLoader();
    try {
      const payload = {
        ...value,
        status: "0",
      };
      await updateProductMaster(value?.id, payload);
      fetchProducts(currentPage);
      toast.success("Product Activated");
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    } finally {
      hideLoader();
    }
  };

  const handleNavigateToIngredients = (product) => {
    navigate(`/ingredients/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  const handleNavigateToProductDetails = (product) => {
    navigate(`/product-details/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  const handleNavigateToProcess = (product) => {
    navigate(`/process/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6
            className="mb-0 text-uppercase"
            style={{ fontFamily: "poppins" }}
          >
            Product  List
          </h6>
          {!readonly && (
            <button
              type="button"
              onClick={() => openAddModal()}
              className="btn btn-primary mb-0"
              style={{ fontFamily: "poppins" }}
            >
              Add Product
            </button>
          )}
        </div>
        <hr className="mt-1" />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div
                className="d-flex position-relative"
                style={{ width: "100%" }}
              >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table
                className="table table-striped table-sm table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Category</th>
                    {/* <th>SubCategory</th> */}
                    {!readonly && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {products.map((prod, index) => (
                    <tr key={prod.id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{prod.title}</td>
                      <td>{prod.category_name}</td>
                      {/* <td>{prod.subcategory_name}</td> */}
                      {!readonly && (
                        <td>
                          {/* Edit Button */}
                          <img
                            src="/assets/images/icons/edit.png"
                            onClick={() => openEditModal(prod)}
                            height="16px"
                            alt="Edit"
                            className="cursor-pointer"
                            title="Edit Product"
                            style={{ cursor: "pointer" }}
                          />
                          &nbsp;&nbsp;&nbsp;

                          {/* Delete Button */}
                          <img
                            src="/assets/images/icons/delete.png"
                            onClick={() => handledeletemodel(prod.product_id)}
                            height="16px"
                            alt="Delete"
                            className="cursor-pointer"
                            title="Delete Product"
                            style={{ cursor: "pointer" }}
                          />
                          {/*       
      <button
        className="btn btn-sm  p-1"
        onClick={() => handleNavigateToIngredients(prod)}
        title="Manage Ingredients"
        style={{ width: "28px", height: "28px" }}
      >
        <i className="fas fa-list-alt" style={{ fontSize: "12px" }}></i>
      </button>
      
      <button
        className="btn btn-sm  p-1"
        onClick={() => handleNavigateToProductDetails(prod)}
        title="Product Details"
        style={{ width: "28px", height: "28px" }}
      >
        <i className="fas fa-info-circle" style={{ fontSize: "12px" }}></i>
      </button>
      
      <button
        className="btn btn-sm  p-1"
        onClick={() => handleNavigateToProcess(prod)}
        title="Process Management"
        style={{ width: "28px", height: "28px" }}
      >
        <i className="fas fa-cogs" style={{ fontSize: "12px" }}></i>
      </button> */}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      <EditProductMaster
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        fetchProducts={() => fetchProducts(currentPage)}
        selectedProduct={selectedProduct}
        AddorEdit={addOrEdit}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default ProductMaster;